import React from "react";
import { GlgIcon, GlgTooltip, GlgTooltipIcon } from "../../shared/components";
import { ComplianceLabelTooltip } from "./label_tooltip";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const ComplianceLabel = ({ course }) => {
  const STATUS_HASH = {
    'compliant': 'compliant',
    'semi-compliant': 'semi-compliant',
    'non-compliant': 'non-compliant'
  };

  const status = course?.status
  if(!status || status === 'manually-added')
    return <></>

  return (
    <span className={`course-compliance-label ${STATUS_HASH[status]}`}>
      {window.I18n.t('courses.bootstrap_course_table_data.whs_compliant')}
      <OverlayTrigger
        overlay={
          <Tooltip className="courses-custom-tooltip">
            <ComplianceLabelTooltip course={course}/>
          </Tooltip>
          }
        placement='right'>
        <GlgIcon iconClass='add-margin-left-5' icon='info-circle'></GlgIcon>
      </OverlayTrigger>
    </span>
  );
};